import axios from 'axios'

class DocumentosApiClient {

    async buscarPorNivelCompraDireta(compraDiretaId) {
        return await axios.get('/compra-direta/api/v1/configuracao/documentos/por-nivel/COMPRA_DIRETA?compraDiretaId='+compraDiretaId)
    }

    async buscarPorNivelProposta() {
        return await axios.get('/compra-direta/api/v1/configuracao/documentos/por-nivel/PROPOSTA')
    }

}

export default new DocumentosApiClient()
